import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { useLanguage } from '@sona/angular-util-common';
import { IntlDatePipe } from 'angular-ecmascript-intl';

@Component({
    selector: 'sona-date-time',
    template: `
        <span [class.tw-font-medium]="highlightDate()">
            {{ date() | intlDate: { day: '2-digit', year: '2-digit', month: '2-digit', locale: locale() } }}
        </span>
        @if (!hideTime()) {
            <small class="tw-text-muted-foreground">
                {{ date() | intlDate: { hour: '2-digit', minute: '2-digit', locale: locale() } }}
            </small>
        }
    `,
    imports: [ IntlDatePipe ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'tw-inline'
    }
})
export class SonaDateTimeComponent {
    readonly locale = useLanguage();

    readonly date = input.required<Date | string>();
    readonly highlightDate = input(false, { transform: booleanAttribute });
    readonly hideTime = input(false, { transform: booleanAttribute });
}
